import type {
  FacetsFilterAttributes,
  LpDestinationAttributes,
  LpInspirationAttributes,
} from 'lc-repository/dist/entities'
import type { StrapiApiResponseOutput } from 'lc-repository/repositories/types'

export const buildStrapiUrl = (path: string) =>
  new URL(
    path,
    import.meta.server
      ? process.env.STRAPI_API
      : useRuntimeConfig().public.strapiApi,
  ).toString()

export const getLpInspirationBySlug = (slug: string, locale: string) =>
  $fetch<StrapiApiResponseOutput<LpInspirationAttributes>>(
    buildStrapiUrl(
      `/api/lp-inspirations/find-by-slug/${slug}?locale=${locale}`,
    ),
  )

export const getLpDestinationBySlug = (slug: string, locale: string) =>
  $fetch<StrapiApiResponseOutput<LpDestinationAttributes>>(
    buildStrapiUrl(
      `/api/lp-destinations/find-by-slug/${slug}?locale=${locale}`,
    ),
  )

export const getAllLpInspiration = () =>
  $fetch<StrapiApiResponseOutput<LpInspirationAttributes[]>>(
    buildStrapiUrl('/api/lp-inspirations?sort=name'),
  )

export const getAllLpDestination = () =>
  $fetch<StrapiApiResponseOutput<LpDestinationAttributes[]>>(
    buildStrapiUrl('/api/lp-destinations?sort=name'),
  )

export const getFacetsFilterByUrl = (slug: string, locale: string) =>
  $fetch<StrapiApiResponseOutput<FacetsFilterAttributes>>(
    buildStrapiUrl(`/api/facets-filter/find-by-url/${slug}?locale=${locale}`),
  )

export const getFacetsFilterByDestinationUrl = (
  destination_slug: string,
  slug: string,
  locale: string,
) =>
  $fetch<StrapiApiResponseOutput<FacetsFilterAttributes>>(
    buildStrapiUrl(
      `/api/facets-filter/find-by-destination-url/${destination_slug}/${slug}?locale=${locale}`,
    ),
  )

export const getFacetsFilterByDestinationId = (destinationId: string) =>
  $fetch<StrapiApiResponseOutput<FacetsFilterAttributes[]>>(
    buildStrapiUrl(
      `/api/facets-filters?filters[destination_id]=${destinationId}`,
    ),
  )
